// Layout
export const APP_SET_LEFT_DRAWER_OPEN = 'APP_SET_LEFT_DRAWER_OPEN';
export const APP_SET_RIGHT_DRAWER_OPEN = 'APP_SET_RIGHT_DRAWER_OPEN';
export const APP_TOOLBAR_HEIGHT = 'APP_TOOLBAR_HEIGHT';

// Alerts
export const APP_SET_ALERT = 'APP_SET_ALERT';

// Routes
export const APP_UPDATE_ROUTES = 'APP_UPDATE_ROUTES';
export const APP_SET_PREVIOUS_ROUTE = 'APP_SET_PREVIOUS_ROUTE';
export const APP_ACTIVE_PAGE_TITLE = 'APP_ACTIVE_PAGE_TITLE';
export const APP_ACTIVE_PAGE_ID = 'APP_ACTIVE_PAGE_ID';

// Settings
export const APP_SET_SETTINGS_CONTENT = 'APP_SET_SETTINGS_CONTENT';

// Modal
export const APP_SET_MODAL_CONTENT = 'APP_SET_MODAL_CONTENT';

// Tooltip
export const APP_SET_TOOLTIP_CONTENT = 'APP_SET_TOOLTIP_CONTENT';

// Gantt
export const APP_SET_GANTT_USER_SELECTIONS = 'APP_SET_GANTT_USER_SELECTIONS';

// Global UUID
export const APP_SET_UUID = 'APP_SET_UUID';